import axios from "axios";

const TRYON_API_URL = "https://tozlu-virtual-api.limonist.dev:4001/tryon";

export const tryItOnService = {
  async processImages(
    humanImage: File,
    clotheImageUrl: string,
  ): Promise<string> {
    const formData = new FormData();
    formData.append("human_image", humanImage, humanImage.name);

    const clotheResponse = await axios.get(clotheImageUrl, {
      responseType: "blob",
    });
    formData.append("clothe_image", clotheResponse.data, "clothe.jpg");

    const response = await axios.post(TRYON_API_URL, formData, {
      responseType: "blob",
      timeout: 120000,
    });

    return URL.createObjectURL(response.data);
  },
};
